import { components } from "react-select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const DropdownIndicator: React.FC<any> = (props) => {
  const CaretDownIcon: React.FC = () => {
    return <ArrowDropDownIcon />;
  };
  return (
    <components.DropdownIndicator {...props}>
      <CaretDownIcon />
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;
